import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import galleryData from '../data/galleryData.json'; // Импортируем сгенерированные данные

function Gallery() {
  // Получаем ключи (имена групп) из объекта данных
  const galleryGroups = Object.keys(galleryData);

  return (
    <Container className="mt-4">
      <h1>Галерея работ</h1>
      <p>Здесь выставлены лучшие работы учеников, разделенные по возрастным группам.</p>

      {galleryGroups.length > 0 ? (
        galleryGroups.map(groupName => (
          <div key={groupName}>
            <hr />
            <h2 className="mb-4">{groupName}</h2>
            <Row>
              {galleryData[groupName].length > 0 ? (
                galleryData[groupName].map((img, index) => (
                  <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
                    <Image src={process.env.PUBLIC_URL + img} thumbnail />
                  </Col>
                ))
              ) : (
                <Col><p>В этой группе пока нет работ.</p></Col>
              )}
            </Row>
          </div>
        ))
      ) : (
        <Col><p>Галерея пуста. Чтобы добавить работы, просто поместите файлы изображений в подпапки `public/gallery_images`.</p></Col>
      )}

    </Container>
  );
}

export default Gallery;
